var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden"},[(_vm.showProgressIndicator)?_c('SubscribeProgressIndicator'):_vm._e(),_vm._v(" "),_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }